// Lightweight external store for the stopwatch's sub-second tick.
// React components subscribe via useStopwatchSeconds() and only the
// subscribers re-render on tick — the rest of the tree is untouched.

import { useSyncExternalStore } from 'react';

type Listener = (value: number) => void;

const listeners: Set<Listener> = new Set();
let currentSeconds = 0;

export function publishStopwatchTick(value: number): void {
  currentSeconds = value;
  listeners.forEach(fn => fn(value));
}

export function getStopwatchSecondsSnapshot(): number {
  return currentSeconds;
}

export function resetStopwatchTick(): void {
  currentSeconds = 0;
  listeners.forEach(fn => fn(0));
}

export function subscribeStopwatchTick(fn: Listener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

export function useStopwatchSeconds(): number {
  return useSyncExternalStore(
    subscribeStopwatchTick,
    getStopwatchSecondsSnapshot,
    getStopwatchSecondsSnapshot
  );
}
